import { Service, ServiceInitializer } from 'elc-service';

const packageInfo = require('../../package.json');
const { name, version } = packageInfo;

export class TranslationsService extends Service {
    constructor(serviceIntializer: ServiceInitializer) {
        super(name, version, serviceIntializer);
    }
}
